jQuery(document).ready(function ($) {
    if ( !$('#employee-profile-detail').length) {
        return;
    }
    
    const clinicalSelect = $('#job-category-clinical');
    const nonClinicalSelect = $('#job-category-nonClinical');

    const clinicalCat = $('.category-clinical');
    const nonClinicalCat = $('.category-nonClinical');

    function toggleJobCategoryByIdealRole(clinicalCategory, loadChange) {
        $('#profile-detail-jobcategory').val(clinicalCategory);
        clinicalCat.removeClass('d-block').addClass('d-none');
        nonClinicalCat.removeClass('d-block').addClass('d-none');
        $('.category-initial').removeClass('d-block').addClass('d-none');

        $(`.category-${clinicalCategory}`).removeClass('d-none').addClass('d-block');
        $('.item-initial').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
        });

        $('.divider-line').hide();
        
        if( clinicalCategory != 'other' ) {
            let jobRoleCategory = $(`#job-category-${clinicalCategory}`).val();

            let setClinicalValue = jobRoleCategory.toLowerCase().replace(/\s+/g, '-');

            if( clinicalCategory == 'clinical' ) {
                $('.clinical-initial').addClass('d-block').removeClass('d-none');
                $(`.item-${setClinicalValue}`).addClass('d-block').removeClass('d-none');
                if( clinicalSelect.val() == 'Other' ) {
                    $('.clinical-initial').addClass('d-none').removeClass('d-block');
                }
                
            } else {
                if( setClinicalValue == 'receptionist' ) {
                    $('.receptionist-initial').addClass('d-block').removeClass('d-none');
                }
                $(`.item-${setClinicalValue}`).addClass('d-block').removeClass('d-none');
            }
            
            $('.divider-line').hide();
            if( jobRoleCategory == 'receptionist' ) {
                $('.line-2').show();
            } else if( jobRoleCategory == 'veterinarian' ) {
                $('.line-1').show();
            } else if( jobRoleCategory == 'vet-nurse' ) {
                $('.line-1').show();
                $('.line-4').show();
            } else {
                //
            }
        }
    }

    // Init display based on current radio selection
    const initialType = $('#ideal-role').val();
    toggleJobCategoryByIdealRole(initialType, 'load');

    // Run on change
    $('#ideal-role').on('change', function () {
        toggleJobCategoryByIdealRole(this.value, 'change');
    });
    
    clinicalSelect.on('select2:select', function (e) {
        let selectedSubItem = e.params.data.id;
        selectedSubItem = selectedSubItem.toLowerCase().replace(/\s+/g, '-')
        
        clinicalCat.addClass('d-block');
        
        $('.clinical-initial').addClass('d-block').removeClass('d-none');
        $('.category-other').removeClass('d-block').addClass('d-none');
        if( selectedSubItem == 'other' ) {
            $('.clinical-initial').removeClass('d-block').addClass('d-none');
        }

        $('.item-initial').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
        });
        $(`.item-${selectedSubItem}`).addClass('d-block').removeClass('d-none');

        $('.divider-line').hide();
        if( selectedSubItem != 'other' ) {
            if( selectedSubItem == 'vet-nurse' ) {
                $('.line-1').show();
                $('.line-4').show();
            } else {
                $('.line-1').show();
            }
        }
    });

    nonClinicalSelect.on('select2:select', function (e) {
        let selectedSubItem = e.params.data.id;
        selectedSubItem = selectedSubItem.toLowerCase().replace(/\s+/g, '-')

        $('.clinical-initial').removeClass('d-block').addClass('d-none');
        $('.category-other').removeClass('d-block').addClass('d-none');
        
        $('.item-initial').each(function () {
            $(this).removeClass('d-block').addClass('d-none');
        });
        $(`.item-${selectedSubItem}`).addClass('d-block').removeClass('d-none');

        if( selectedSubItem == 'receptionist' ) {
            $('.receptionist-initial').addClass('d-block').removeClass('d-none');
            $('.item-receptionist').removeClass('d-none');
        } else {
            $('.receptionist-initial').removeClass('d-block').addClass('d-none');
            $('.item-receptionist').addClass('d-none');
        }

        $('.divider-line').hide();
        if( selectedSubItem == 'receptionist' ) {
            $('.line-2').show();
        }
    });
});
